<!-- <mat-card class="menupannel">
  <div class="resUser">
    <button mat-flat-button (click)="showMyDrive()">
      Main Workspace <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div> 
</mat-card> -->

<div class="taskcontainer">


  <div class="myDriveOverlay" (click)="showMyDrive()" [ngClass]="{ open: showmyDrive }"></div>
 

  <div class="right">
    <mat-card class="filter">
      <div class="pageHeading">
       
        <!-- <button mat-icon-button color="primary" (click)="showTaskLists()"> 
          <mat-icon *ngIf="!showTaskListsLeft" >arrow_back_ios</mat-icon>
          <mat-icon *ngIf="showTaskListsLeft" >arrow_forward_ios</mat-icon>
        </button> -->
        
        <!-- <button mat-icon-button color="primary" (click)="showMyDrive()"> <mat-icon>menu_open</mat-icon></button> -->

        <button mat-flat-button  [matMenuTriggerFor]="notification" class="user-button">
          {{myTaskText}} <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu class="customPanel" #notification="matMenu">
          <mat-card class="filterOptionList">
            <div class="fillist">           
              <div class="filterlist">
           
                <div class="lList">
                  <span class="name" (click)="onFilterByMyTask(1,'All Task')">All Task</span>

                  <button mat-icon-button>
                    <mat-icon class="star">bookmark</mat-icon>
                  </button>

                  <button mat-icon-button class="remove">
                    <mat-icon class="">highlight_off</mat-icon>
                  </button>
                </div>
                <div class="lList">
                  <span class="name" (click)="onFilterByMyTask(2,'Created by me')">Created by me</span>

                  <button mat-icon-button>
                    <mat-icon class="star">bookmark</mat-icon>
                  </button>

                  <button mat-icon-button class="remove">
                    <mat-icon class="">highlight_off</mat-icon>
                  </button>
                </div>
                <div class="lList">
                  <span (click)="onFilterByMyTask(3,'Assigned to me')" class="name">Assigned to me</span>

                  <button mat-icon-button>
                    <mat-icon class="star">bookmark</mat-icon>
                  </button>

                  <button mat-icon-button class="remove">
                    <mat-icon class="">highlight_off</mat-icon>
                  </button>
                </div>
                <div class="lList">
                  <span class="name" (click)="onFilterByMyTask(4,'My Role')">My Role</span>

                  <button mat-icon-button>
                    <mat-icon class="star">bookmark</mat-icon>
                  </button>

                  <button mat-icon-button class="remove">
                    <mat-icon class="">highlight_off</mat-icon>
                  </button>
                </div>
                
              </div>
            </div>
          </mat-card>
        </mat-menu>
      
      </div>


  
      <div class="sort">
        <button mat-icon-button *ngIf="showMoveToOption" (click)="moveTo(MoveTo)">
          <mat-icon>low_priority</mat-icon>
        </button>
  
        <button mat-icon-button *ngIf="showMoveToOption" (click)="SaveAsTemplateMultiple(saveAsTemplateDialog)">
          <mat-icon>save</mat-icon>        
        </button>

        <button mat-icon-button *ngIf="showMoveToOption" (click)="deleteMultipleTask()">
          <mat-icon>delete</mat-icon>
        </button>
       
        <button mat-stroked-button color="primary" [ngClass]="{'active':preorityArray.length>0}" [matMenuTriggerFor]="priority">{{preoritytext}}<mat-icon>arrow_drop_down</mat-icon></button>
        <mat-icon class="cancelFilter" (click)="clearPreoority()" *ngIf="preorityArray.length>0">close</mat-icon>
        <mat-menu #priority="matMenu">
          <button mat-menu-item (click)="onFilterByPreority(1,'Lowest')">Lowest</button>
          <button mat-menu-item (click)="onFilterByPreority(2,'Low')">Low</button>
          <button mat-menu-item (click)="onFilterByPreority(3,'Medium')">Medium</button>
          <button mat-menu-item (click)="onFilterByPreority(4,'High')">High</button>
          <button mat-menu-item (click)="onFilterByPreority(5,'Highest')">Highest</button>
        </mat-menu>

        <button mat-stroked-button color="primary" [ngClass]="{'active':dueDatetext!=='Due Date'}" [matMenuTriggerFor]="dueDate">{{dueDatetext}}<mat-icon>arrow_drop_down</mat-icon></button>
        <mat-icon class="cancelFilter" *ngIf="dueDatetext!=='Due Date'" (click)="clearDuedate()">close</mat-icon>
        <mat-menu #dueDate="matMenu">
          <button mat-menu-item (click)="GettaskByFilter('Today')">Today</button>
          <button mat-menu-item (click)="GettaskByFilter('Tomorrow')">Tomorrow</button>
          <button mat-menu-item (click)="GettaskByFilter('This Week')">This Week</button>
          <button mat-menu-item (click)="GettaskByFilter('Next Week')">Next Week</button>
          <button mat-menu-item (click)="GettaskByFilter('Overdue')">Overdue</button>
        </mat-menu>

      </div>

      <div class="search">      
  
        <!-- <mat-form-field appearance="fill" style="width:230px;">
          <mat-label>Search task</mat-label>
          <input matInput type="text" (input)="getSearchResults()" [(ngModel)]="value"/>
          <button mat-button *ngIf="value" matSuffix
            mat-icon-button aria-label="Clear" (click)="clearSerachText()">
            <mat-icon>close</mat-icon>
          </button>
          <button *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="value = ''">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field> -->
<!-- 
        <button mat-icon-button matTooltipClass="tooltip"
          matTooltip="Customize Coloumn">
          <mat-icon>view_column</mat-icon>
        </button>
        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Filters">
          <mat-icon>filter_list</mat-icon>
        </button> -->
        <!-- <button mat-icon-button color="primary" class="addnew"
          (click)="createNewTask()">
          <mat-icon>add</mat-icon>
        </button> -->
        
        <div class="add">
          <button mat-button color="primary" [matMenuTriggerFor]="menu"><mat-icon>add</mat-icon> Task</button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="createNewTask()">
              <mat-icon>create</mat-icon>Create Task</button>          
            <button mat-menu-item (click)="ImportTaskTemplate(importTasktemplate)">
              <mat-icon>import_export</mat-icon>Import Task</button>     
              
            <button *ngIf="taskListID > 0" mat-menu-item  (click)="createGroup()">
            <mat-icon>group_add</mat-icon>
            New Group
          </button>      
          </mat-menu>
        </div>

        
      </div>

    </mat-card>
   <div class="tableHolder">
    <mat-card class="task_holder--group--items--row cellHeader">

      <div class="task_header_holder cvcxxcv">
        <ng-container>
          <div class="task-cell cellName">
            <div class="Headeroutside">
              <mat-checkbox class="taskcheck" color="primary" [disabled]="ShowNoRecordFound"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()">
               </mat-checkbox>   
            </div>
            Title
          </div>      
          <div class="task-cell cellDueDate">Required</div>   
          <div class="task-cell cellDueDate">Assignee</div>
          <div class="task-cell cellDueDate">Due date</div>
          <div class="task-cell cellStatus">Status</div>
          <div class="task-cell cellPriority">Priority</div>
          <div class="task-cell cellAction">Action</div>
        </ng-container>     
      </div>

    </mat-card>

    <div class="task_holder" *ngFor="let column of columns" style="width:100%">
      <div class="task_holder--group" cdkDropList [cdkDropListData]="column.groups"
        (cdkDropListDropped)="dropGroup($event)">
        <mat-card class="task_holder--group--items" *ngFor="let group of column.groups" cdkDropListGroup cdkDrag
          [cdkDragDisabled]="group.dragDisabled" [cdkDragData]="group">
          <h2 *ngIf="taskListID>0 && group.id!=0">

            <ng-container *ngIf="group.id==0">
              {{group.title}}
            </ng-container>

            <input *ngIf="group.id>0" type="text" maxlength="50" (change)="onChangeGroupName($event,group)"
              value="{{group.title}}">
  
            <span class="delete">          

              <ng-container *ngIf="group.id>0">
                <button mat-icon-button class="trash" (click)="removeGroup(group)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </ng-container>
            

            </span>

          </h2>

          <form [formGroup]="statusGroup">
            <mat-card style="width:100%" class="example-list" cdkDropList id="{{group.id}}"
              [cdkDropListData]="group.items" (cdkDropListDropped)="dropItem($event)"
              [cdkDropListConnectedTo]="getConnectedList()">

              <div class="task_holder--group--items--row" *ngFor="let item of group.items; let i = index" cdkDrag
                [cdkDragData]="item" [cdkDragDisabled]="taskListID==0">

                <div class="task-cell cellName">
                  <div class="outside">                   
                    <mat-checkbox class="taskcheck" color="primary" (change)="isAllSelectedRow($event,item)"
                      (change)="$event ? selection.toggle(item) : null" [checked]="selection.isSelected(item)">
                    </mat-checkbox>
                  </div>

                  <button mat-icon-button (click)="markComplete(item)"
                    [ngClass]="{ markComplete: item.status==completedTaskStatusID }">
                    <mat-icon>check_circle_outline</mat-icon>
                  </button>

                  <div class="tname" (click)="getTaskDetail(item)">
                    <span *ngIf="taskListID==0 && taskListIDSharedWithMe==0" (click)="getTaskDetail(item)"
                      class="taskColor" [ngStyle]="{'background-color': item.color}"></span>
                    <span *ngIf="taskListID>0 || taskListIDSharedWithMe>0" (click)="getTaskDetail(item)"
                      class="taskColor" [ngStyle]="{'background-color': item.colourCode}"></span>

                    <span *ngIf="taskListID==0 && taskListIDSharedWithMe==0" (click)="getTaskDetail(item)"
                      class="taskTitle">{{ item.taskTitle }}</span>
                    <span *ngIf="taskListID>0 || taskListIDSharedWithMe>0" (click)="getTaskDetail(item)"
                      class="taskTitle">{{ item.taskTitle }}</span>
                   
                    <div class="taskstatusCount">
                      <!-- <span class="complete"
                        *ngIf="item.completedSubTaskCount > 0">{{item.completedSubTaskCount}}</span>
                      <span class="working" *ngIf="item.inprogressTaskCount > 0">{{item.inprogressTaskCount}}</span> -->
                    </div>

                  </div>

                     <span *ngIf="!item.isInternal" class="externalTask" matTooltipClass="tooltip"
                      matTooltip="External task">
                      <mat-icon>arrow_outward</mat-icon>
                    </span>

                
                </div>                      
                           
                    <div class="task-cell cellDueDate">
                    <span *ngIf="item.isRequired==true" class="externalTask" matTooltipClass="tooltip" (click)="MakeTaskRequired(item,false)" matTooltip="Required">
                      <mat-icon style="color: red;">check</mat-icon>
                    </span>

                    <span *ngIf="item.isRequired==false" class="externalTask" matTooltipClass="tooltip" (click)="MakeTaskRequired(item,true)">
                      <mat-icon>check</mat-icon>
                    </span>
                  </div>

                     <div class="task-cell cellAssigne" (click)="getTaskDetail(item)">
                    <span> 

                      <div class="userpicinfo">                       
                     
                          <ul class="assignList">

                            <ng-container *ngFor="let item of getAssigne(item.taskAssignedEntity); let i = index; trackBy: trackByFn; " >
                               <li *ngIf="i <= 3">
                                <ng-container *ngIf="item.image; else showName">
                                  <div class="userImage" matTooltipClass="tooltip"   matTooltip="{{item.name}}">
                                    <img src="{{item.image}}" alt="{{item.name}}">
                                  </div>
                                </ng-container>
  
                                <ng-template #showName>
                                    <span class="shortName" matTooltipClass="tooltip" matTooltip="{{item.name}}">
                                      {{ getShortName(item.name) }}
                                    </span> 
                                </ng-template>
                              </li>
                              <li *ngIf="i > 3 && i == 4">
                                <span class="shortName">
                                  +{{4}}
                                </span> 
                              </li>
                            </ng-container>

                            <ng-container *ngIf="getAssigne(item.taskAssignedEntity).length == 0;">
                             <li> -  </li>
                           </ng-container>

                          </ul>

                       
                      </div>
                     

                    </span>
                  </div>


                <div class="task-cell cellDueDate" (click)="getTaskDetail(item)">
                  <p *ngIf="item.dueDate == null">
                    <mat-icon class="greyIcon">
                      event
                    </mat-icon>
                  </p>

                  <p *ngIf="item.dueDate != null">
                    {{ item.dueDate| date: "MM/dd/yyyy" }}
                  </p>
                </div>

                <div class="task-cell cellStatus">


                  <ng-select [readonly]="SingleTaskArchived==true" formControlName="status{{item.taskId}}" [searchable]="false" [clearAllText]="false"
                    (change)="onTaskListStatusChange($event,item)" class="status_dropdown">

                    <ng-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                      <span class="statusOptions" [style.background]="getBackground(stat.taskStatusID)">{{
                        stat.taskStatusName }}</span>
                    </ng-option>

                  </ng-select>

                </div>


                <div class="task-cell cellPriority">

                  <ng-select [readonly]="SingleTaskArchived==true" class="priority_dropdown" formControlName="priority{{item.taskId}}" [searchable]="false"
                    [clearAllText]="false" (change)="onTaskListPriorityChange($event,item)">

                    <ng-option *ngFor="let priority of taskPriorityNameColorCode" [value]="priority.val">
                      <span class="statusOptions"
                        [ngStyle]="{'color': priority.color}"><mat-icon>{{priority.icon}}</mat-icon>{{ priority.name
                        }}</span>
                    </ng-option>

                  </ng-select>


                </div>
                 <!-- <div *ngIf="SingleTaskArchived==false"   class="task-cell cellAction"> -->
                <div *ngIf="SingleTaskArchived==false" class="task-cell cellAction">

                  <span mat-icon-button [matMenuTriggerFor]="taskSubActions"><mat-icon>more_vert</mat-icon>
                  </span>
                  <mat-menu class="taskMatMenu" #taskSubActions="matMenu" xPosition="before">
                   
                    <button mat-menu-item (click)="openTaskUrl(item)">
                      <mat-icon>content_copy</mat-icon>Copy URL
                    </button>
                    <button mat-menu-item (click)="SaveAsTemplateForSingleTask(saveAsTemplateTaskDialog,item)">                      
                      <mat-icon>save</mat-icon>
                      Save as Template
                    </button>
                    <button mat-menu-item (click)="sendManualTaskReminder(sendReminder,item)">
                      <mat-icon> email</mat-icon>
                      Send Email Notification</button>
                    <button mat-menu-item (click)="ArchiveTask(item)">
                      <mat-icon>archive</mat-icon>
                      Archive
                    </button>
                    <button mat-menu-item (click)="deleteTask(item)">
                      <mat-icon>delete</mat-icon>
                      Delete
                    </button>
                  </mat-menu>
                </div>
                           
                <div *ngIf="ShowNoRecordFound" class="noRecordFound">No record found</div>
            
              </div>
            </mat-card>
          </form>
         
        </mat-card>
        
        
      </div>
      
    </div>
  </div>
    <!-- <form [formGroup]="statusGroup">
    <mat-card class="allTaskHolder">
      <div class="zui-wrapper">       
        <div class="zui-scroller"> 
        
          <mat-table *ngIf="!ShowNoRecordFound" class="zui-table scrollfix" [dataSource]="dataSource" cdkDropList [cdkDropListData]="dataSource.data"
          (cdkDropListDropped)="dropTable($event)"  [cdkDropListDisabled]="taskListID==0">
       
            <ng-container matColumnDef="taskTitle">
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox class="taskcheck" color="primary" [disabled]="ShowNoRecordFound"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()">
               </mat-checkbox>                
                <span class="ml-10" >Title</span>
              </mat-header-cell>
              <mat-cell  class="taskName"  [ngClass]="{'showCheckBox': showAllCheckBoxes || selection.isSelected(task) }"  *matCellDef="let task">   
                <div class="outside">
                  <mat-icon class="moveIcon" *ngIf="taskListID>0" cdkDragHandle>drag_handle</mat-icon>

               <mat-checkbox  class="taskcheck"color="primary" (change)="isAllSelectedRow($event,task)"
               (change)="$event ? selection.toggle(task) : null"
               [checked]="selection.isSelected(task)">
               </mat-checkbox>
                </div>

                <button mat-icon-button (click)="markComplete(task)" class="notComplete" 
                 [ngClass]="{ markComplete: task.status==completedTaskStatusID }">
                  <mat-icon>check_circle_outline</mat-icon>
                </button>

                

                <div class="tname" >
                
                  <span *ngIf="taskListID==0" (click)="getTaskDetail(task)" class="taskColor" [ngStyle]="{'background-color': task.color}"></span>
                  <span *ngIf="taskListID>0" (click)="getTaskDetail(task)" class="taskColor" [ngStyle]="{'background-color': task.colourCode}"></span>

                  <span *ngIf="taskListID==0" (click)="getTaskDetail(task)" class="taskTitle">{{ task.taskTitle }}</span>
                  <span *ngIf="taskListID>0" (click)="getTaskDetail(task)" class="taskTitle">{{ task.taskTitle }}</span>
                                                               
                  <div class="taskstatusCount">                    
                    <span class="complete" *ngIf="task.completedSubTaskCount > 0" >{{task.completedSubTaskCount}}</span>
                    <span class="working" *ngIf="task.inprogressTaskCount > 0" >{{task.inprogressTaskCount}}</span>
                                   
                  </div>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dueDate">
              <mat-header-cell *matHeaderCellDef  class="w100">Due Date</mat-header-cell>
              <mat-cell (click)="getTaskDetail(task)" class="w100" *matCellDef="let task">
                <p *ngIf="task.dueDate == null">
                  <mat-icon class="greyIcon">
                    event
                  </mat-icon>
                </p>
                <p *ngIf="task.dueDate != null">
                  {{ task.dueDate | date: "MM/dd/yyyy" }}                 
                </p>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef  class="w100">Status</mat-header-cell>
              <mat-cell class="w100" *matCellDef="let task">             
                <div class="taskStatusPriority">
                  <ng-select [readonly]="SingleTaskArchived==true" formControlName="status{{task.taskId}}" [searchable]="false" [clearAllText]="false"
                    class="status_dropdown ngselect" (change)="onTaskListStatusChange($event,task)">
                    <ng-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                      <span class="statusOptions" [style.background]="getBackground(stat.taskStatusID)">
                        {{stat.taskStatusName }}
                      </span>
                    </ng-option>
                </ng-select>
                </div>
              </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="priority">
              <mat-header-cell *matHeaderCellDef  class="w100">Priority</mat-header-cell>
              <mat-cell class="w100" *matCellDef="let task">
                <div class="taskStatusPriority">
                  <ng-select [readonly]="SingleTaskArchived==true" class="priority_dropdown ngselect" formControlName="priority{{task.taskId}}" [searchable]="false"
                  [clearAllText]="false" (change)="onTaskListPriorityChange($event,task)" >
  
                  <ng-option *ngFor="let priority of taskPriorityNameColorCode" [value]="priority.val">
                    <span class="statusOptions"
                      [ngStyle]="{'color': priority.color}"><mat-icon>{{priority.icon}}</mat-icon>{{ priority.name
                      }}</span>
                  </ng-option>
                  </ng-select>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Action">
              <mat-header-cell *matHeaderCellDef  class="w100" >Action</mat-header-cell>
              <mat-cell  class="w100" *matCellDef="let task">
                   
                <div class="forHover">
                      
                  <span mat-icon-button [matMenuTriggerFor]="taskSubActions"><mat-icon>more_vert</mat-icon>
                  </span>
                  
                  </div>                  

                 
                  <mat-menu  class="taskMatMenu" #taskSubActions="matMenu" xPosition="before">                   
                    <button *ngIf="SingleTaskArchived==false" mat-menu-item (click)="openTaskUrl(task)">
                      <mat-icon>content_copy</mat-icon>Copy URL</button>

                    <button *ngIf="SingleTaskArchived==false" mat-menu-item (click)="SaveAsTemplateForSingleTask(saveAsTemplateTaskDialog,task)">                      
                      <mat-icon>save</mat-icon>
                      Save as Template
                    </button>

                    <button *ngIf="SingleTaskArchived==false" mat-menu-item (click)="sendManualTaskReminder(sendReminder,task)">
                      <mat-icon> email</mat-icon>Send Email Notification</button>

                      <button *ngIf="SingleTaskArchived==false" mat-menu-item (click)="ArchiveTask(task)">
                       <mat-icon>archive</mat-icon> Archive</button>

                    <button *ngIf="SingleTaskArchived==false" mat-menu-item (click)="deleteTask(task)">
                      <mat-icon>delete</mat-icon> Delete</button>
                   

                    <button *ngIf="SingleTaskArchived==true" mat-menu-item (click)="UnArchiveTask(task)">
                      <mat-icon>unarchive</mat-icon>UnArchive</button>

                  </mat-menu>       
                  
                  
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag [cdkDragData]="row"></mat-row>            
          </mat-table>

          </div>
          
          <div *ngIf="ShowNoRecordFound" class="noRecordFound">No record found</div>
         
      </div>
    </mat-card>
    </form> -->

  
    <ng-container *ngIf="showAssignedTask">
      <mat-card class="createTask" cdkDrag cdkDragBoundary=".right">
        <app-task-assign [taskId]="taskId" [fromList]="true"
         (closeAssignedTask)="closeTask($event)">
        </app-task-assign>
      </mat-card>
    </ng-container>
    

    <ng-container *ngIf="showAttachTask">
      <div class="createTask" cdkDrag cdkDragBoundary=".right">
        <app-task-attach-ccc [taskId]="taskId" [fromList]="true"
          (closeAssignedTask)="closeAttach($event)">
        </app-task-attach-ccc>
      </div>
    </ng-container> 

    <ng-container *ngIf="showCreateTask">
      <mat-card class="createTask ssss" cdkDrag cdkDragBoundary=".right">
        <app-addtask
          (getCloseCreateTask)="getCloseCreateTask()"
          (getSaveTask)="getSaveTask()"
          [taskId]="taskId"
          [taskListID]="taskListID"
          [moduleName]="moduleNames"
          [name]="name"
          [email]="email"
          [imageUrl]="imageUrl"
          [transactionID]="transactionIDForTask"
          [typeId]="typeIdForTask" [typeIdDrp]="TypeIdDrp">
        </app-addtask>
      </mat-card>
    </ng-container>

  </div>
</div>


<app-task-details
  *ngIf="showTaskDetail"
  [ngClass]="{ open: showTaskDetail }"
  (closeTaskDetail)="closeTaskDetail($event)"
  (closeSaveTaskDetail)="closeSaveTaskDetail($event)"
  (showPI)="showPIntelligence($event)"
  [taskId]="taskId"
  [mainModulename]="mainModuleName" [SingleTaskArchived]="SingleTaskArchived"
  [showAddGroupButtonCore]="showAddGroupButtonCore">
</app-task-details>


<!-- <app-task3c-tasklists  *ngIf="showTaskListsLeft"
 [ngClass]="{'open': showTaskListsLeft}"
 (closeTaskList)="closeTaskList($event)"
 [modulename]="Module"
 [mainModulename]="mainModuleName"
 [transactionID]="transactionIDForTask"
 [typeId]="typeIdForTask"
 (getMyTask)="getMyTask()"
 (OpenTaskLists)=OpenTaskLists($event)>
</app-task3c-tasklists> -->


<app-add-pi
  [ngClass]="{ open: showProcess }"
  (closeLinkPI)="closePIntelligence($event)">
</app-add-pi>



<ng-template #MoveTo>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span> 
    Move To
    <button mat-icon-button (click)="closeMoveto()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
       
      <div class="drive mainLink">              
        <div class="folderName" *ngFor="let tasklist of taskListFolderForMoveTo; let i = index">
         
          <div class="" style="display: flex; width: 100%;">

            <div class="nm" (click)="getTaskListsForMoveTo(tasklist,i)">
            
              <mat-icon class="arrow_right"  aria-hidden="true">
                chevron_right 
               </mat-icon>
                       
            <mat-icon class="type">folder</mat-icon>
            {{tasklist.taskListFolderName}}            
          </div>                 
       
          </div>
          
          <ng-container *ngIf="taskListsForMoveTo.length>0 && i === expandedIndexmoveTo">
            <ng-container *ngFor="let list of taskListsForMoveTo">
  
              <div class="subTaskList" style="margin-left:0px;margin-right:0px;"
              (click)="SelectTaskList(list)">  

                <mat-icon class="type">list</mat-icon>
                <p  [ngClass]="{ 'active': taskListIDMoveTo === list.taskListID }"> 
                {{list.taskListName}}      
               </p>

            </div>  
                      
            </ng-container>
          </ng-container>

        </div>
      </div>         
    

  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeMoveto()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary"
    [disabled]="!ButtonForMoveTo" (click)="MoveToTaskList()">
     MoveTo
     <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
     </mat-spinner></mat-icon>
   </button>
  </mat-dialog-actions>

</ng-template>


<ng-template #saveAsTemplateDialog>
  <form [formGroup]="addTemplateForm"> 
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
    Save As Template
    <button mat-icon-button (click)="closeSaveAsTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>  

    <mat-form-field appearance="fill">
      <mat-label>Select Category</mat-label>
      <mat-select formControlName="folderID">
        <mat-option *ngFor="let stat of taskCategoryList" [value]="stat.taskTemplateCategoryID">
            {{ stat.taskTemplateCategoryName }}
        </mat-option>
    </mat-select>    
    </mat-form-field>

      <mat-form-field class="">
        <mat-label>Template Name</mat-label>
        <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="add template name"/>
      </mat-form-field>

  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary"
    [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty" 
    (click)="AddTaskTemplate(addTemplateForm.value)">
     Add
     <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
     </mat-spinner></mat-icon>
   </button>
  </mat-dialog-actions>
</form>
</ng-template>



<ng-template #sendReminder>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Send Email Notification
    <button mat-icon-button (click)="closeSendReminder()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="search">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput maxlength="200" placeholder="Add email" [(ngModel)]="repeatTaskEmail">
        </mat-form-field>
      </div>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeSendReminder()">Cancel</button>
    <button mat-flat-button color="primary" 
    (click)="onSendManualTaskReminder()">
    Send
  </button>
  </mat-dialog-actions>
</ng-template>



<ng-template #saveAsTemplateTaskDialog>
  <form [formGroup]="addTemplateForm">
    <h2 mat-dialog-title>
      <!-- {{taskTitleForSingleTask}} -->
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Save/Update Template
      <button mat-icon-button (click)="closeSaveAsTemplateForSingleTask()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <mat-radio-group color="primary" aria-label="Select an option">
        <mat-radio-button value="0" (change)="OnCategoryChangeForSingleTask(0)" [checked]="categoryTypeForSingleTask==0"
          style="margin-right: 15px;">My Templates</mat-radio-button>
          <mat-radio-button value="2" *ngIf="isOfficeAdmin || isOrganizationAdmin" (change)="OnCategoryChangeForSingleTask(2)" [checked]="categoryTypeForSingleTask==2"
          style="margin-right: 15px;">Save as Organization Template</mat-radio-button>
        <!-- <mat-radio-button value="2" *ngIf="isOrganizationAdmin" (change)="OnCategoryChangeForSingleTask(2)" [checked]="categoryTypeForSingleTask==2"
          style="margin-right: 15px;">Save as Organization Template</mat-radio-button> -->
        <mat-radio-button value="1" *ngIf="isSuperAdmin" (change)="OnCategoryChangeForSingleTask(1)" [checked]="categoryTypeForSingleTask==1">
          Save Global Template Only</mat-radio-button>
      </mat-radio-group>

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="getTabDetailsForSingleTask($event)">
        <mat-tab label="New">

          <div class="tabContainer">
            <div class="d-flex">

              <mat-form-field appearance="fill">
                <mat-label>Select Category</mat-label>
                <mat-select formControlName="folderID">
                  <mat-option *ngFor="let stat of filteredTaskCategoryList" [value]="stat.taskTemplateCategoryID">
                    {{ stat.taskTemplateCategoryName }}
                  </mat-option>
                </mat-select>

              </mat-form-field>

              <button class="addBtn" mat-icon-button color="primary" (click)="openDialogAddWithRef()">
                <mat-icon>add</mat-icon> </button>
            </div>
            <mat-form-field class="">
              <mat-label>Template Name</mat-label>
              <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="add template name" />
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab label="Update Existing">
          <div class="tabContainer">

            <div class="searchSelectCat">
              <div class="selectCat">
                <mat-form-field appearance="fill">
                  <mat-label>Select Category</mat-label>
                  <mat-select (selectionChange)="getSelectTaskCategoryForSingleTask($event)">
                    <mat-option value="0">All</mat-option>
                    <mat-option *ngFor="let stat of filteredTaskCategoryList" [value]="stat.taskTemplateCategoryID">
                      {{ stat.taskTemplateCategoryName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>


              <div class="search">
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Search</mat-label>
                  <input matInput maxlength="20" placeholder="Search Template"
                    (input)="searchTemplateForSingleTask($event.target.value)">
                </mat-form-field>
              </div>
            </div>


            <div class="tempalteList">
              <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
                <tr>
                  <th class="formName">Template Name</th>
                  <!-- <th>Category Name</th> -->
                  <th class="actBtn">Action</th>
                </tr>
                <tr *ngFor="let template of TaskTemplatesListForSingleTask"
                  [ngClass]="{ 'active': template.taskId === taskTemplateIDForSingleTask}">

                  <td class="formName">
                    {{template.templateName}}
                  </td>

                  <td class="actBtn">
                    <button mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip"
                      matTooltip="Select" (click)="SelectTemplateForAddTaskListForSingleTask(template)"><mat-icon>post_add</mat-icon>
                    </button>
                  </td>
                </tr>
              </table>
              <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Records Found</div>
            </div>
          </div>

        </mat-tab>
      </mat-tab-group>

    </mat-dialog-content>

    <mat-dialog-actions *ngIf="showNew" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty" (click)="AddTaskTemplateForSingleTask(addTemplateForm.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="showExisting" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplateForSingleTask()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="!updateTaskTemplateTasksButton" (click)="AddSingleTaskTemplateForSingleTask(addTemplateForm.value)">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

  </form>
</ng-template>



<ng-template #importTasktemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Template Gallery

    <!-- <button mat-stroked-button color="primary" class="import" *ngIf="selectedTemplate.length>0" (click)="importTaskTemplates()">Import</button> -->

    <button mat-icon-button (click)="closeImportTaskTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
 

    <div class="template-holder">
      <div class="left">

        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="onTaskListTabChangeForTaskImport($event)" value="My Template">
            <mat-option value="My Template">My Template</mat-option>
            <mat-option value="Organization">Organization</mat-option>
            <!-- <mat-option value="Global">Global</mat-option> -->
          </mat-select>
        </mat-form-field>

        <div class="list" #categoryList>
          <ul>
            <li (click)="getTaskListThroughCategoryForTaskImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }" >All</li>
            <ng-container  *ngFor="let stat of filteredTaskCategoryList; let i = index">
              <li (click)="getTaskListThroughCategoryForTaskImport(stat.taskTemplateCategoryID, i+1)" [ngClass]="{'active': currentIndex == i+1 }"  > {{ stat.taskTemplateCategoryName }}</li>
            </ng-container>           
          </ul>
        
        </div>

      </div>
     <div class="right"> 
       
      

       <div class="searrch">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput maxlength="20" placeholder="Search Template"
            (input)="searchTemplateForSingleTask($event.target.value)">
        </mat-form-field>
       </div>
  
      

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
            <tr>
              <th> </th>
              <th>Template Name</th>             
              <th class="">&nbsp;</th>
            </tr>
            <tr *ngFor="let template of  TaskTemplatesListForSingleTask"
             [ngClass]="{ 'active': template.taskId === taskTemplateIDForSingleTask}">

             <td>
              <mat-checkbox color="primary" (change)="getCheckboxValues($event, template)">
              </mat-checkbox>
            </td> 

              <td class="formName">
                {{template.templateName}}
              </td>            

              <td>
                &nbsp;
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
        </div>

     
  
     </div>
  </div>  

  <section class="importTo" *ngIf="selectedTemplate.length>0">
    <p>Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
    <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp;
    <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
    <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
  </section>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeImportTaskTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="selectedTemplate.length>0"
      (click)="importTaskTemplates()">
      Import     
    </button>
  </mat-dialog-actions> 

</ng-template>



<app-loader></app-loader>

